import React, { useEffect, useState } from "react";

import { Tab, Button, Modal } from "react-bootstrap";
import { useDataFetch } from "./../../hooks/useDataFetch";
import { useDegrees } from "./../../hooks/useDegrees";
import CurrencyInput from "react-currency-input-field";
import { toast } from "react-toastify";
import { isEndDateAfterStartDate, isInteger, months } from "../utils";

const Monthly = () => {
  const [yearFilter, setYearFilter] = useState(
    new Date().getFullYear().toString()
  );
  const [degreeFilter, setDegreeFilter] = useState("");
  const [items, setItems] = useState([]);

  const { getData, patchData, postData, invalidateQuery } = useDataFetch();

  const { degrees: datadegreeList } = useDegrees(yearFilter);

  const { data } = getData(["cost-monthlies"], "/cost-monthlies", {
    enabled: true,
  });

  const { mutate: createCostMonthly, isLoading: isCreateLoading } = postData(
    "/cost-monthlies",
    {},
    {},
    {
      onSuccess: (data) => {
        const result = data?.data?.data;
        setItems((prev) => {
          const index = prev.findIndex(
            (item) =>
              result.degree_id == item.degree_id &&
              result.year == item.year &&
              result.month == item.month
          );
          prev[index].id = result.id;
          return [...prev];
        });
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  const { mutate: updateCostMonthly, isLoading: isUpdateLoading } = patchData(
    "/cost-monthlies",
    {},
    {
      onSuccess: (data) => {
        toast.success("Se completo la acción correctamente.");
      },
    }
  );

  useEffect(() => {
    if (degreeFilter) {
      let items = [];
      let degreeName = "";
      if (degreeFilter) {
        degreeName = datadegreeList?.find((e) => e.id == degreeFilter);
      }
      for (const element of months) {
        let monthly;
        if (data) {
          monthly = data?.data?.find(
            (e) =>
              element.id == e.month &&
              e.year == yearFilter &&
              e.degree_id == degreeFilter
          );
        }
        items.push({
          month_name: element.name,
          month: element.id,
          id: monthly ? monthly.id : null,
          degree_name: `${degreeName?.level} ${degreeName?.degree}`,
          degree_id: degreeFilter,
          year: yearFilter,
          value: monthly ? monthly.value : null,
          start_date: monthly ? monthly.start_date : null,
          end_date: monthly ? monthly.end_date : null,
        });
      }
      setItems(items);
    }
  }, [data, degreeFilter, yearFilter]);

  useEffect(() => {
    if (datadegreeList?.length > 0) {
      setDegreeFilter(datadegreeList[0].id);
    }
  }, [datadegreeList]);

  const save = (e) => {
    if (!e.value || !isInteger(e.value)) {
      toast.error("El valor no es correcto ");
      return;
    }
    if (e.start_date && e.end_date) {
      const valid_date = isEndDateAfterStartDate(e.start_date, e.end_date);
      if (!valid_date) {
        toast.error("Las fechas no son correctas");
        return;
      }
    } else {
      toast.error("Las fechas son requeridas");
      return;
    }

    if (e?.id) {
      updateCostMonthly(e);
    } else {
      createCostMonthly(e);
    }
  };

  return (
    <Tab.Container defaultActiveKey="all">
      <div className="d-flex">
        <select
          className="form-control mb-3"
          onChange={(e) => setYearFilter(e.target.value)}
          value={yearFilter}
          style={{ width: 100 }}
        >
          {[2025, 2026, 2027, 2028, 2029, 2030].map((year) => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>
        <select
          className="form-control mb-3 ml-3"
          onChange={(e) => setDegreeFilter(e.target.value)}
          value={degreeFilter}
          style={{ width: 200 }}
        >
          {datadegreeList?.map((e) => (
            <option key={e.id} value={e.id}>
              {e.level} {e.degree}
            </option>
          ))}
        </select>
      </div>

      <div className="table-responsive">
        <table className="table card-table display dataTablesCard dataTable no-footer">
          <thead>
            <tr>
              <th>Año</th>
              <th>Mes</th>
              <th>Grado</th>
              <th>Mensualidad</th>
              <th>Fecha inicial</th>
              <th>Fecha final</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {items?.map((e) => (
              <tr key={e.month}>
                <td>{e.year}</td>
                <td>{e.month_name}</td>
                <td>{e.degree_name}</td>
                <td>
                  <CurrencyInput
                    value={e.value}
                    className="form-control"
                    decimalsLimit={0}
                    decimalSeparator=","
                    groupSeparator="."
                    onValueChange={(value, name, values) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.month == e.month
                        );
                        prev[index].value = value;

                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.start_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.month == e.month
                        );
                        prev[index].start_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={e.end_date ?? ""}
                    onChange={(value) =>
                      setItems((prev) => {
                        const index = prev.findIndex(
                          (item) => item.month == e.month
                        );
                        prev[index].end_date = value.target.value;
                        return [...prev];
                      })
                    }
                  />
                </td>
                <td>
                  <Button
                    type="button"
                    onClick={() => save(e)}
                    disabled={isCreateLoading || isUpdateLoading}
                  >
                    Guardar
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Tab.Container>
  );
};

export default Monthly;
